import React from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { InviteMemberModal } from '@adsk/acs-admin-ui-components-shared-components';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import {
  StyledModalAlertMessageContainer,
  StyledModalIconContainer,
  StyledModalAlertText,
} from './styles';

const InviteTrialMemberModal = ({ ...rest }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const cancelInviteConfirmationProps = {
    cancelButtonLabel: T.translate('CANCEL_CONFIRMATION_BACK_BUTTON'),
    confirmationButtonLabel: T.translate('CANCEL_CONFIRMATION_CANCEL_BUTTON'),
    message: T.translate('CANCEL_CONFIRMATION_MESSAGE'),
    title: T.translate('CANCEL_CONFIRMATION_TITLE'),
  };

  return (
    <InviteMemberModal
      {...rest}
      companies={[]}
      accountUsers={[]}
      cancelInviteConfirmationProps={cancelInviteConfirmationProps}
      modalConfirmButtonText={T.translate('FOOTER_CONFIRM_BUTTON')}
      variant="trial"
      modalTitle={T.translate('TITLE')}
      roles={[]}
      data-testId="InviteTrialMemberModal_Component"
    >
      <StyledModalAlertMessageContainer data-testId="InviteTrialMemberModal_Alert">
        <StyledModalIconContainer>
          <AlertInformationIcon />
        </StyledModalIconContainer>
        <StyledModalAlertText>
          {T.translate('BODY_ALERT_INFORMATION')}
        </StyledModalAlertText>
      </StyledModalAlertMessageContainer>
    </InviteMemberModal>
  );
};

InviteTrialMemberModal.propTypes = {};

export default InviteTrialMemberModal;
